import tag from './tag';
import post from './post';
import reply from './reply';
import token from './token';
import widget from './widget';
import category from './category';
import log from './log';
import media from './media';
import page from './page';

export default {
  category, tag, post, reply, widget, token, log, media, page
};
